"use client";

import React, { Component } from "react";
import { requestError, requestSuccess } from "utils/requestHandler";
import { Get, Post, Put, Delete, PostForm } from "utils/axios";
import { getItem } from 'utils/tokenStore'
import i18n from 'i18n'
import _ from 'lodash';

const HOC = (WrappedComponent) => {
  class WithHOC extends Component {
    state = {
      loading: false,
      devices: [],
      firmwares: [],
      firmware: null,
      selectedFirmware: null,
      firmwareScope: null,
      firmwareOtaStatus: null,
    };

    onChangeHOC = (key, val) => this.setState({ [key]: val });

    load = (param) => this.setState({ loading: param });

    getFirmware = (version) => {
          Get(
            `/api/firmware/${version}`,
            this.getFirmwareSuccess,
            error => requestError(error),
            this.load
          )
        }

    getFirmwares = () => {
      Get(
        `/api/firmware`,
        this.getFirmwaresSuccess,
        error => requestError(error),
        this.load
      )
    }

    getFirmwaresSuccess = payload => {
      this.setState({firmwares:payload.DATA})
    }

    getFirmwareSuccess = payload => {
      this.setState({firmware:payload.DATA})
    }

    addFirmware = (version, description, firmware) => {
      const form_data = new FormData();
      form_data.append('version', version);
      form_data.append('description', description);
      form_data.append('firmware', firmware);
      console.log(form_data)
      PostForm(
        `/api/firmware`,
        form_data,
        this.addFirmwareSuccess,
        error => requestError(error),
        this.load
      )
    }

    addFirmwareSuccess = payload => {
      requestSuccess(i18n.t('FirmwarePage.messages.added'))
      this.getFirmwares()
    }

    deleteFirmware = (version) => {
      Delete(
        `/api/firmware/${version}`,
        this.deleteFirmwareSuccess,
        error => requestError(error),
        this.load
      )
    }

    deleteFirmwareSuccess = payload => {
      requestSuccess(i18n.t('FirmwarePage.messages.deleted'))
      this.getFirmwares()
    }

    getDevices = () => {
      Post(
        `/api/getRegDevices`,
        {},
        this.getDevicesSuccess,
        error => requestError(error),
        this.load
      )
    }
    
    getDevicesSuccess = payload => {
      this.setState({ devices: payload.DATA })
    }

    getFirmwareScope = (version) => {
      Get(
        `/api/firmware/${version}/scope`,
        this.getFirmwareScopeSuccess,
        error => requestError(error),
        this.load
      )
    }

    getFirmwareScopeSuccess = payload => {
      this.setState({ firmwareScope: payload })
    }

    updateFirmwareScope = (version, applyToAll, deviceIds) => {
      Post(
        `/api/firmware/${version}/scope`,
        {
          version,
          apply_to_all: applyToAll,
          device_ids: deviceIds,
        },
        this.updateFirmwareScopeSuccess,
        error => requestError(error),
        this.load
      )
    }

    updateFirmwareScopeSuccess = payload => {
      requestSuccess(i18n.t('FirmwarePage.messages.scopeUpdated'))
      this.getFirmwares()
    }

    pushFirmware = (version) => {
      Post(
        `/api/firmware/${version}/push`,
        {},
        this.pushFirmwareSuccess,
        error => requestError(error),
        this.load
      )
    }

    pushFirmwareSuccess = payload => {
      const failedMacs = payload?.FAILED_MACS || []
      const publishedMacs = payload?.PUBLISHED_MACS || []
      if (!payload?.RESULT || failedMacs.length > 0) {
        requestError(
          i18n.t('FirmwarePage.messages.pushFailed', { count: failedMacs.length, macs: failedMacs.join(', ') })
        )
        return
      }
      requestSuccess(i18n.t('FirmwarePage.messages.pushConfirmed', { count: publishedMacs.length }))
    }

    getFirmwareOtaStatus = (version) => {
      Get(
        `/api/firmware/${version}/ota-status`,
        this.getFirmwareOtaStatusSuccess,
        error => requestError(error),
        this.load
      )
    }

    getFirmwareOtaStatusSuccess = payload => {
      this.setState({ firmwareOtaStatus: payload })
    }

    render = () => {
      return (
        <WrappedComponent
          {...this.props}
          {...this.state}
          onLoading={this.state.loading}
          onChangeHOC={this.onChangeHOC}
          getFirmwares={this.getFirmwares}
          addFirmware={this.addFirmware}
          deleteFirmware={this.deleteFirmware}
          getDevices={this.getDevices}
          getFirmwareScope={this.getFirmwareScope}
          updateFirmwareScope={this.updateFirmwareScope}
          pushFirmware={this.pushFirmware}
          getFirmwareOtaStatus={this.getFirmwareOtaStatus}
        />
      );
    };
  }
  return WithHOC;
};

export default HOC;
